import { css } from '@emotion/react';

const styles = {
  container: css`
    background-color: #80c5e5;
    width: 100%;
    margin-block: 0;
  `,
};

export type Props = {
  className?: string;
};

export const Divider = (props: Props) => {
  return <hr css={styles.container} className={props.className} />;
};
